export const URL_FACEBOOK = 'https://www.facebook.com/sharer/sharer.php';
export const URL_TWITTER = 'https://twitter.com/intent/tweet';
export const URL_KAKAOSTORY = 'https://story.kakao.com/share';